import { endsWith, replace, chain, reduce, cloneDeep } from "lodash"

const UNMODELED_SUFFIX = "_UNMODELED"
const TICKER_PATTERN = /^[A-Za-z0-9_-]{3,20}$/

export const validateSwapTicker = (name) => {
  return name.match(TICKER_PATTERN)
}

export function sanitizeBasketTicker(ticker) {
  // We need make sure we only replaced the last occurrence of '_UNMODELED' in the ticker
  if (endsWith(ticker, UNMODELED_SUFFIX)) {
    return ticker.substr(0, ticker.length - UNMODELED_SUFFIX.length)
  }
  return ticker
}

export function getBasketLabel(securityId) {
  return replace(securityId, new RegExp(`${UNMODELED_SUFFIX}$`, "g"), " (unmodeled)")
}

export function squashUnmodeledBaskets(positionSet) {
  if (!positionSet || !Array.isArray(positionSet.dates)) {
    return positionSet
  }

  const allDates = positionSet.dates.map(dateEntry => {
    const newDate = cloneDeep(dateEntry)

    const swaps = dateEntry.swaps
    if (Array.isArray(swaps) && swaps.length > 0) {
      const positionGroups = chain(swaps)
        .groupBy(position => sanitizeBasketTicker(position.id))
        .value()

      const combinedSwaps = chain(positionGroups)
        .map(groupPositions => {
          if (groupPositions.length === 1) {
            return groupPositions[0]
          }

          const combined = { ...groupPositions[0] }
          combined.id = sanitizeBasketTicker(combined.id)
          combined.economicExposure = reduce(groupPositions, (sum, pos) => sum + pos.economicExposure, 0)
          return combined
        }).value()

      newDate.swaps = combinedSwaps
    }

    return newDate
  })

  return {
    ...positionSet,
    dates: allDates,
  }
}
